export class ClearingHouseList{
    id: string="00000000-0000-0000-0000-000000000000";
    clearingHouseId:string="00000000-0000-0000-0000-000000000000";
    name: string;
    modifier: string;
    formatTypeLid: string | null;
    tradingPartnerID2: number | null;
    receiverIDQualifierLid: string | null;
    fileNameFormatType: number | null;
    receiverIDQualifier_Name: string;
    senderIdQualifier_Name: string;
    formatTypeName: string;
    receiverId: string;
    senderId: string;
    senderIDQualifierLid: string | null;
    agencyId: string | null;
    isinActive: boolean|null;
    clearingHousePayorMapping: ClearingHousePayorMapping[] = [];
}

export class ClearingHousePayorMapping {
  id: string="00000000-0000-0000-0000-000000000000";
  clearingHouseId: string="00000000-0000-0000-0000-000000000000";
  groupPayorId:string="00000000-0000-0000-0000-000000000000";
  payorID: string;
  status: boolean = false;
}

export class GroupPayorList{
    id:string="00000000-0000-0000-0000-000000000000";
    AgencyId:string="00000000-0000-0000-0000-000000000000";
    GroupLid: string="00000000-0000-0000-0000-000000000000";
    PayorName: string;
    BillingFullName: string;
    AddressLine1: string;
    AddressLine2: string;
    City: string;
    State: string;
    Zip: string;
    PhoneNumber: string;
    DefaultBillType: string;
    payorId: string;
    I837PInsTypeLid: number;
    StateFormat: string;
    PayorEmail: string;
    GroupName: string;
    ATYPICAL: boolean;
    IsIcd10FromClient: boolean;
    Icd10: string;
    WaiverFlag: boolean;
}

export class searchfilterDetails {
  Filter_clearingHouseId: string = '';
  Filter_Name: string = '';
  Filter_ReceiverIdQualifier: any;
  Filter_ReceiverId: string = '';
  Filter_SenderId: string = '';
  Filter_SenderIdQualifier: any;
  Filter_Modifier: string = '';
}

export class sortingObj
{
    itemperpage : number =20;
    currentPgNo : number = 1;
    shortcolumn : string = "name";
    shortType : string = 'asc';
}

export class DropList {
  label: string;
  value: string;
}

export class functionpermission {
  clearinghousecreate: boolean = true;
  clearinghousedelete: boolean = true;
  clearinghouseupdate: boolean = true;
}

export class WhereCondition {
  field: string="name";
  value: string="";
  operator: string="startswith";
  orderNo: number=1;
  predicate: string="and";
  type: string="string";
  matchCase:boolean=false;
}
export class GetCHListBo {
    orderColumn: string = "name";
    orderType: string= "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    userId: string="00000000-0000-0000-0000-000000000000";
    field: string = "name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyId: string="00000000-0000-0000-0000-000000000000";
    isinActive: boolean|null;
}
export class columnWidth {
  column: string = "";
  width: number = 0;
}

export class ColumnChangeBO {
  id: string;
  userid: number=0;
  agencyId: number=0;
  column: string;
}
